import { render, staticRenderFns } from "./IbePackageRoom.vue?vue&type=template&id=002fc82b"
import script from "./IbePackageRoom.vue?vue&type=script&lang=js"
export * from "./IbePackageRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports